import { formatUserPermissions } from '../Components/Utilities/formatUserPermissions';

export function isPermittedOption(id: string): boolean {
  const userPermissions = formatUserPermissions();
  switch (id) {
    case 'assigned_user':
      return !!userPermissions?.['Approval Forms']?.['Assign User To Requisition'];
    case 'note':
      return !!userPermissions?.['Approval Forms']?.['Manage Approval Form Notes'];
    default:
      return true;
  }
}
